import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useLabels, usePrefs } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import Chip from './Chip';
import { ResultsContext } from '../contexts';
import { g } from '../global-constants';

const RecentSearches = ({ preventModalClose }) => {
	const { recentSearches, handleClearHistory, handleClearHistoryNoClose } =
		useContext(ResultsContext);

	const labels = useLabels();
	const { display } = usePrefs();
	const isPanelMode = display === g.NAVIGATION_DRAWER;

	const headingClassName = setClassNames(
		isPanelMode
			? ['mt-0', 'h4', 'text-capitalize', 'sts-panel-heading']
			: ['mt-0', 'h4', 'text-capitalize']
	);

	const clearFunction = preventModalClose
		? handleClearHistoryNoClose
		: handleClearHistory;

	return (
		<div role="group">
			<div
				className={setClassNames([
					'd-flex',
					'justify-content-between',
					'align-items-center'
				])}
			>
				<div id="recent-searches-heading" className={headingClassName}>
					{labels.get('RECENT_SEARCHES')}
				</div>
				<button
					className={setClassNames([
						'btn',
						'btn-link',
						'p-0',
						'text-danger',
						'font-weight-light',
						'btn-sm'
					])}
					onClick={clearFunction}
					type="button"
					aria-label={labels.get('CLEAR_SEARCH_HISTORY')}
				>
					{labels.get('CLEAR_HISTORY')}
				</button>
			</div>
			{recentSearches?.slice(0, 5).map((recentSearch) => (
				<Chip key={recentSearch.value} recentSearch={recentSearch} />
			))}
		</div>
	);
};

RecentSearches.propTypes = {
	preventModalClose: PropTypes.bool
};
export default React.memo(RecentSearches);
